import moment from 'moment'
import PlatformActions from './PlatformActions'

export default class CQ9FISHActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'SLOT',
      gameCode: 'CQ9-SLOT-001',
      platform: 'CQ9',
    }

    this.gameName = 'JumpHigh'
  }

  getBetMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betTime,
      betAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `rel-bet-${txnId}:cq9`, // rel-bet-6805412868:cq9
      roundId: `${roundId}`, // 6805412868
      betType: null,
      currency,
      betTime, // 2026-06-15T13:41:09.962+08:00
      betAmount,
      jackpotBetAmount: 0,
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'bet',
      txns,
    }

    return JSON.stringify(message)
  }

  getSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      updateTime,
      betTime,
      turnover,
      betAmount,
      winAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `${txnId}`, // 6805412868
      refPlatformTxId: null,
      settleType: 'roundId',
      updateTime, // 2026-06-15T13:45:56.712+08:00
      roundId: `${roundId}`, // 6805412868
      betType: null,
      betTime,
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      jackpotWinAmount: 0,
      gameInfo: {
        dataList: [
          {
            mtcode: `rel-win-${txnId}:cq9`,
            amount: winAmount,
            eventtime: moment(betTime).format('YYYY-MM-DD HH:mm:ss'),
            validbet: 0,
          },
        ],
      },
    }))

    const message = {
      action: 'settle',
      txns,
    }

    return JSON.stringify(message)
  }

  getResettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      updateTime,
      betTime,
      turnover,
      betAmount,
      winAmount,
      resettleTime,
      debitAmount,
      creditAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `${txnId}`, // 6805412868
      refPlatformTxId: null,
      settleType: 'roundId',
      updateTime,
      roundId: `${roundId}`, // 6805412868
      betType: null,
      betTime,
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      gameInfo: {
        dataList: [
          {
            mtcode: `rel-resettle-${txnId}:cq9`,
            amount: winAmount,
            eventtime: moment(resettleTime).format('YYYY-MM-DD HH:mm:ss'),
            validbet: 0,
          },
        ],
        ...(debitAmount && { [`debit_re-debit-${txnId}:cq9_adjustAmount`]: debitAmount }),
        ...(creditAmount && { [`credit_re-debit-${txnId}:cq9_adjustAmount`]: creditAmount }),
        resettleTime,
      },
    }))

    const message = {
      action: 'resettle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: `rel-bet-${txnId}:cq9`, // rel-bet-6805412868:cq9
      roundId: `${roundId}`, // 6805412868
    }))

    const message = {
      action: 'cancelBet',
      txns,
    }

    return JSON.stringify(message)
  }
}
